import { render, staticRenderFns } from "./_permalink.vue?vue&type=template&id=059c849e&"
import script from "./_permalink.vue?vue&type=script&lang=js&"
export * from "./_permalink.vue?vue&type=script&lang=js&"
import style0 from "./_permalink.vue?vue&type=style&index=0&id=059c849e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SliderBanner: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/SliderBanner.vue').default})
